import {Center, Image, makeStorageUrl} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import type {ReactNode} from 'react';

import {isNil} from 'ramda';

import type {ImageAssetRef} from '@dms/api/new-vehicle';

import type {Nullish} from 'shared/web';

const THUMBNAIL_UNITS = 8;
const THUMBNAIL_PX = 64;

/**
 * A list row's image, else `fallback` (e.g. a colour swatch). `reserveSlot` keeps the thumbnail's
 * space in rows without an image, so names in a list that shows any image stay aligned. The image
 * is decorative: the row names the item next to it. `onImageError` belongs to the list's query.
 */
export function CatalogueThumbnail(props: {
  image: ImageAssetRef | Nullish;
  reserveSlot: boolean;
  onImageError: () => void;
  fallback?: ReactNode;
}) {
  return match(props)
    .with({image: Pattern.nonNullable}, ({image}) => {
      const src = isNil(image.url)
        ? null
        : makeStorageUrl(image.url, THUMBNAIL_PX, THUMBNAIL_PX, 'cover');
      return (
        <Image
          key={src}
          src={src}
          alt=""
          width={THUMBNAIL_UNITS}
          minWidth={THUMBNAIL_UNITS}
          height={THUMBNAIL_UNITS}
          fit="cover"
          borderRadius="small"
          onError={props.onImageError}
        />
      );
    })
    .with({reserveSlot: true}, () => (
      <Center width={THUMBNAIL_UNITS} height={THUMBNAIL_UNITS} shrink={0}>
        {props.fallback}
      </Center>
    ))
    .otherwise(() => <>{props.fallback}</>);
}
